var _templateObject = _taggedTemplateLiteral(["\n    ", "\n  "], ["\n    ", "\n  "]),
    _templateObject2 = _taggedTemplateLiteral(["\n  table {\n    border-spacing: 0 0.5rem;\n  }\n\n  @media only screen and (max-width: 768px) {\n    table,\n    thead,\n    tbody,\n    th,\n    td,\n    tr {\n      display: block;\n    }\n\n    thead tr {\n      display: none;\n    }\n\n    td {\n      /* Behave  like a \"row\" */\n      position: relative;\n      padding-left: 50% !important;\n    }\n\n    td:before {\n      /* Now like a table header */\n      position: absolute;\n      /* Top/left values mimic padding */\n      top: 6px;\n      left: 6px;\n      width: 45%;\n      padding-right: 10px;\n      white-space: nowrap;\n\n      font-weight: bold;\n    }\n\n    ", "\n  }\n"], ["\n  table {\n    border-spacing: 0 0.5rem;\n  }\n\n  @media only screen and (max-width: 768px) {\n    table,\n    thead,\n    tbody,\n    th,\n    td,\n    tr {\n      display: block;\n    }\n\n    thead tr {\n      display: none;\n    }\n\n    td {\n      /* Behave  like a \"row\" */\n      position: relative;\n      padding-left: 50% !important;\n    }\n\n    td:before {\n      /* Now like a table header */\n      position: absolute;\n      /* Top/left values mimic padding */\n      top: 6px;\n      left: 6px;\n      width: 45%;\n      padding-right: 10px;\n      white-space: nowrap;\n\n      font-weight: bold;\n    }\n\n    ", "\n  }\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from "styled-components";

function createContent(cols) {
  var styles = "";

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = cols[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var col = _step.value;

      styles += "\n    td:nth-of-type(" + col.colID + "):before {\n      content: '" + col.colTitle + "';\n    }\n    ";
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return css(_templateObject, styles);
}

export var TableMobileContainer = styled.div(_templateObject2, function (props) {
  return props.cols && createContent(props.cols);
});